import script from "./ServerDomains.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServerDomains.vue?vue&type=script&setup=true&lang=ts"

import "./ServerDomains.vue?vue&type=style&index=0&id=6f509cd6&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f509cd6"]])

export default __exports__